'use strict'

module.exports = require('./colors.json')



//////////////////
// WEBPACK FOOTER
// ./~/css-color-keywords/index.js
// module id = 217
// module chunks = 0